module.exports = __webpack_public_path__ + "img/logo.7ce86e87.png";